module.exports = __webpack_public_path__ + "static/img/img_logo.9cbb9129.png";